import WorkIdUploadScreen from './WorkIdUploadScreen';

export default WorkIdUploadScreen;
